<template>
  <section class="mt-2">
    <v-dialog persistent v-model="formDialogVisible" max-width="400px">
      <v-card>
        <v-form ref="form" v-model="valid">
          <v-toolbar color="grey lighten-3 font-weight-bold " flat dense>
            <span class="subtitleFontsize">Currency Info</span>
            <v-spacer></v-spacer>
            <v-btn depressed small icon @click="closeFormDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="pt-0">
            <v-row no-gutters>
              <v-col cols="12" md="12">
                <label class="my-0 rounded labelFontsize required">
                  Currency Name
                </label>
                <v-autocomplete
                  v-model="countryCurrency.currency_name"
                  placeholder="Currency Name"
                  dense
                  outlined
                  class="rounded"
                  :rules="Currency_Name"
                  :items="currency_list"
                  @input="updateCurrencyCode"
                ></v-autocomplete>
                <label class="my-0 rounded labelFontsize required">
                  Currency code
                </label>
                <v-text-field
                  v-model="countryCurrency.currency_code"
                  dense
                  outlined
                  disabled
                  placeholder="Currency Code"
                  class="rounded"
                >
                </v-text-field>
                <label class="my-0 rounded labelFontsize required">
                  Applied For
                </label>
                <v-autocomplete
                  v-model="countryCurrency.applied_for"
                  placeholder="Applied For "
                  dense
                  outlined
                  class="rounded"
                  :rules="Applied_For"
                  :items="appliedfor"
                ></v-autocomplete>
                <label class="my-0 rounded labelFontsize"> Is Default </label>
                <v-switch
                  v-model="countryCurrency.is_default"
                  height="0px"
                  color="success"
                  dense
                ></v-switch>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider class="pa-0 ma-0"></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                depressed
                color="primary"
                class="text-capitalize"
                small
                @click="onSubmitFor()"
              >
                {{ countryCurrency.id ? "Update" : "Add" }}
              </v-btn>
              <v-btn
                depressed
                small
                color="primary"
                class="text-capitalize ms-2"
                @click="closeFormDialog()"
                outlined
              >
                <v-icon small class="me-2">mdi-close-circle-outline</v-icon>
                Cancel
              </v-btn>
            </v-card-actions>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <template>
      <v-row class="mt-5">
        <v-btn
          depressed
          class="text-capitalize ms-8 me-3"
          small
          color="primary"
          @click="openFormDialog()"
        >
          <v-icon small class="me-2">mdi-content-save-plus-outline</v-icon>Add
        </v-btn>
        <v-btn depressed @click="downloadExcelsheet" color="primary" small
          ><v-icon small>mdi-file-excel-outline</v-icon>Export
        </v-btn>

        <v-spacer></v-spacer>

        <v-col cols="12" lg="4" xs="12">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Type here to filter the table data."
            single-line
            class="me-4 mx-2"
            dense
            clearable
          ></v-text-field>
        </v-col>
      </v-row>
    </template>
    <v-data-table
      fixed-header
      height="55vh"
      :headers="headers"
      dense
      :search="search"
      class="p-1"
      :items="allowedCurrency"
      loading-text="Loading... Please wait"
    >
      <template v-slot:item.actions="{ item }">
        <v-icon small color="primary" class="mr-2" @click="editItem(item)">
          mdi-content-save-edit-outline
        </v-icon>
        <v-icon small color="primary" @click="deleteItem(item)">
          mdi-trash-can-outline
        </v-icon>
      </template>
      <template v-slot:item.is_default="{ item }">
        <v-switch
          v-model="item.is_default"
          height="0px"
          color="success"
          dense
          @change="isactiveupdate(item)"
        ></v-switch>
      </template>
    </v-data-table>
    <!-- delete dialog -->
    <v-dialog persistent v-model="dialogDelete" width="500">
      <v-card>
        <v-card-title class="border border-bottom">Delete</v-card-title>
        <v-card-text class="h5 py-3"
          >Are you sure you want to delete?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            small
            color="primary"
            outlined
            @click="deleteItemConfirm"
          >
            <v-icon>mdi-check</v-icon>
          </v-btn>
          <v-btn
            depressed
            small
            color="primary"
            outlined
            @click="dialogDelete = false"
            ><v-icon>mdi-close</v-icon></v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <loading :active="loader" :opacity="0.9" color="#ff6b00" />
  </section>
</template>

<script>
import alerts from "@/mixins/alerts";
import { AllowedCurrency } from "@/utils/validation.js";
import Loading from "vue-loading-overlay";
import setupService from "@/services/SetupService/setupService";

export default {
  name: "Addmastercat",
  mixins: [alerts],
  data() {
    return {
      ...AllowedCurrency,
      valid: true,
      formDialogVisible: false,
      dialogDelete: false,
      loader: false,
      validate: false,
      search: "",
      editedIndex: -1,
      allowedCurrency: [],
      currency_list: [],
      countryCurrency: {
        country: "",
        currency_code: "",
        currency_name: "",
        is_default: false,
        applied_for: "",
      },
      appliedfor: [
        { text: "Channel Partner", value: "1" },
        { text: "Payout Partner", value: "2" },
      ],
      headers: [
        {
          text: "Currency Code",
          value: "currency_code",
        },
        { text: "Currency Name", value: "currency_name" },
        { text: "Is default", value: "is_default" },
        { text: "Applied For", value: "applied_for_data.value" },

        { text: "Created By", value: "created_by", sortable: false },
        { text: "Action", value: "actions", sortable: false },
      ],
    };
  },
  props: {
    selectedItems: {
      type: Array,
    },
    prameterid: {
      type: String,
    },
  },
  components: {
    Loading,
  },

  computed: {},
  mounted() {
    this.getAllCounCurrencyList();
    // this.getcountryCurrencyList();
    this.getcountryList();
  },

  methods: {
    stoploader() {
      setTimeout(() => {
        this.loader = false;
      }, 400);
    },
    async downloadExcelsheet() {
      if (this.allowedCurrency) {
        this.exportToExcel(
          this.headers,
          this.allowedCurrency,
          "allowedCurrency",
        );
      }
    },
    openFormDialog() {
      this.formDialogVisible = true;
      this.countryCurrency = {};
      this.countryCurrency.country = this.$route.query.iso3;
      console.log(this.countryCurrency.country);
      this.countryCurrency.is_default = false;
      if (this.validate == true) {
        this.$refs.form.resetValidation();
      }
    },

    closeFormDialog() {
      this.formDialogVisible = false;
      this.validate = true;
      this.$refs.form.reset();
    },

    editItem(item) {
      this.formDialogVisible = true;
      this.editedIndex = this.allowedCurrency.indexOf(item);
      this.countryCurrency = Object.assign({}, item);
      console.log(this.countryCurrency);
    },

    async getAllCounCurrencyList() {
      this.loader = true;
      try {
        const response = await setupService.getCountryCurrencyData(
          this.$route.query.iso3,
        );
        if (response.data.status_code === 200) {
          this.allowedCurrency = response.data.data[0].reverse();
          this.stoploader();
          console.log(response, "response");
        }
        // else if (response.data.status_code === 401) {
        //   this.allowedCurrency = [];
        //   this.returnNewToken();
        //   this.getAllCounCurrrencyList();
        // }
        else {
          this.loader = false;
          this.allowedCurrency = [];
          // this.showAlertError('Failed:'+response.data.message)
        }
        console.log("Currency", response);
      } catch (e) {
        console.error(e);
        this.loader = false;
        this.allowedCurrency = [];
      }
    },
    onSubmitFor() {
      if (this.countryCurrency.id) {
        console.log("details");
        this.update();
      } else {
        console.log("else");
        this.save();
        // console.log('update')
      }
      this.validate = true;
    },
    async save() {
      const validate = this.$refs.form.validate();
      if (validate) {
        try {
          const responseData = await setupService.addCountryCurrencyData(
            this.countryCurrency,
          );
          if (responseData.data.status_code == 200) {
            this.showAlertSuccess("Saved: " + responseData.data.message);
            this.getAllCounCurrencyList();
            this.formDialogVisible = false;
          }
          //  else if (responseData.data.status_code === 401) {
          //   this.returnNewToken();
          //   this.save();
          // }
          else {
            this.showAlertError("Failed: " + responseData.data.message);
            this.formDialogVisible = false;
          }
          console.log("respose data", responseData);
        } catch (e) {
          console.error(e);
          this.showAlertError("Something went wrong please try again later .");
        }
      }
    },
    async update() {
      const validate = this.$refs.form.validate();
      if (validate) {
        try {
          const responseData = await setupService.updateCountryCurrencyData(
            this.countryCurrency.id,
            this.countryCurrency,
          );
          if (responseData && responseData.data.status_code == 200) {
            this.showAlertSuccess("Updated: " + responseData.data.message);
            this.getAllCounCurrencyList();
            this.formDialogVisible = false;
          }
          // else if (responseData.data.status_code === 401) {
          //   this.returnNewToken();
          //   this.update();
          // }
        } catch (e) {
          console.error(e);
          this.showAlertError("Something went wrong please try again later.");
        }
      }
    },
    async isactiveupdate(isactive) {
      console.log(isactive.is_default);
      this.loader = true;
      try {
        const responseData = await setupService.activeCurrencyUpdate(
          isactive.id,
          isactive.is_default,
        );
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess("Updated: " + responseData.data.message);
          this.getAllCounCurrencyList();
          this.stoploader();
        }
        // else if (responseData.data.status_code == 401) {
        //   this.returnNewToken();
        //   this.isactiveupdate(isactive);
        // }
        else {
          this.stoploader();
          this.showAlertError("Failed:" + responseData.data.message);
        }
      } catch (e) {
        console.error(e);
        this.loader = false;
        this.showAlertError("Something went wrong please try again later.");
      }
    },
    deleteItem(item) {
      this.dialogDelete = true;
      this.deleted_id = item.id;
      console.log(this.deleted_id);
    },
    async deleteItemConfirm() {
      this.loader = true;
      try {
        const responseData = await setupService.deleteCurrencyData(
          this.deleted_id,
        );
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess("Deleted: " + responseData.data.message);
          this.getAllCounCurrencyList();
          this.stoploader();
          this.dialogDelete = false;
        } else {
          this.stoploader();
          this.showAlertError("Failed:" + responseData.data.message);
        }
      } catch (e) {
        console.error(e);
        this.loader = false;
        this.showAlertError("Something went wrong please try again later.");
      }
    },
    async getcountryList() {
      try {
        const response = await setupService.getCountrysetupList();
        if (response.data.status_code === 200) {
          this.currency_list = response.data.data.map((i) => ({
            text: i.currency_name,
            value: i.currency_name,
            currency_code: i.currency_code,
          }));
        }
        // else if (response.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getcountryList();
        // }
        console.log("Currency", response);
      } catch (e) {
        console.error(e);
        this.CountryList = [];
      }
    },
    updateCurrencyCode() {
      const selectedCurrency = this.currency_list.find(
        (currency) => currency.text === this.countryCurrency.currency_name,
      );

      if (selectedCurrency) {
        this.countryCurrency.currency_code = selectedCurrency.currency_code;
      }
    },
  },
};
</script>

<style>
.required:after {
  content: " *";
  color: red;
}
</style>
